<template>
  <div @click="updateDisplay" class="my-2 border-2 h-24 shadow-md mx-sm my-xsm px-sm py-xsm flex items-center content-center border-default hover:bg-light-grey hover:shadow-lg justify-around rounded-3xl shadow-sharp cursor-pointer w-1/2 font-text">
    <div>
      <img v-if="isImage" class="w-20" alt="Logo" :src="img">
    </div>
    <div class="flex flex-col w-8/12">
      <span class="flex-grow mx-auto text-2xl text-default">{{ title }}</span>
      <span v-if="title === 'Purdue University'" class="flex-grow mx-auto text-xl text-default">Honors College</span>
      <span class="flex-grow mx-auto text-xl text-default">{{ position }}</span>
    </div>
  </div>
  <div v-if="this.display" @click="updateDisplay" class="z-20 fixed m-auto inset-x-0 inset-y-0 backdrop-filter backdrop-blur-lg bg-opacity-30 bg-dark-grey cursor-pointer"></div>
  <AchievementPopup v-if="this.display" :title="title" :status="position" :attachmentOne="attachmentOne" :attachmentTwo="attachmentTwo" :desc="desc" :images="images"/>
</template>

<script>
import AchievementPopup from '@/components/AchievementPopup'

export default {
  name: 'Achievement',
  components: { AchievementPopup },
  props: {
    title: {
      type: String,
      required: true
    },
    position: {
      type: String,
      required: true
    },
    img: {
      type: String,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    attachmentOne: {
      type: Object,
      required: false
    },
    attachmentTwo: {
      type: Object,
      required: false
    },
    desc: {
      type: String,
      required: false
    },
    images: {
      type: Array,
      required: false
    }
  },
  data: function () {
    return {
      isImage: false,
      display: false
    }
  },
  created: function () {
    if (this.img.split('/')[1] === 'img') {
      this.isImage = true
    }
  },
  methods: {
    updateDisplay: function () {
      this.display = !this.display
    }
  }
}
</script>

<style scoped>

</style>
